export default "__VITE_ASSET__DPqDmkOs__"